import React, { useState, useRef, useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import strings from 'localization/strings';
import Collapse from '@material-ui/core/Collapse';
import Button from '@material-ui/core/Button';

import { makeStyles } from 'styles/util';

const ReadMoreSection = ({ children, fadeBackgroundColor, maxHeight = '100px' }) => {
    const useStyles = makeStyles(({theme, colors}) => ({
        collapse: {
            position: 'relative',
			marginBottom: theme.spacing(2),
            '&.fade::after': {
                content: '""',
                position: 'absolute',
                bottom: 0,
                left: 0,
                right: 0,
                height: '20px',
                background: `linear-gradient(rgba(239, 239, 239, 0), ${fadeBackgroundColor || colors.mediumLightGrey})`
            },
            '&.fade.MuiCollapse-entered::after': {
                display: 'none'
            }
        }
    }));
    const classes = useStyles();
    const [expanded, setExpanded] = useState(false);
    const [shouldShowButton, setShouldShowButton] = useState(false);
    const sectionRef = useRef();

    useEffect(() => {
        if (sectionRef.current && sectionRef.current.scrollHeight > parseInt(maxHeight, 10)) {
            setShouldShowButton(true);
        } else {
            setShouldShowButton(false);
        }
    }, [children, maxHeight]);

    return (
        <>
            <Collapse in={expanded} collapsedSize={maxHeight} className={clsx(classes.collapse, { fade: shouldShowButton})} ref={sectionRef}>
				{children}
            </Collapse>
            {shouldShowButton && (
                <Button onClick={() => setExpanded(!expanded)}>
                    {!expanded ? strings.readMore : strings.readLess}
                </Button>
            )}
        </>
    );
};

ReadMoreSection.propTypes = {
    children: PropTypes.node.isRequired,
    maxHeight: PropTypes.string,
    fadeBackgroundColor: PropTypes.string
};

export default ReadMoreSection;
